import * as tslib_1 from "tslib";
import highlightDisplayText from './suggestionsContextMenu/highlightDisplayText';
import { suggestionSelected } from '../actions/publicActions';
import { CLICK_ACTION_SOURCE } from '../searchConstants';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import { TooltipHost, TooltipOverflowMode, } from 'office-ui-fabric-react/lib/Tooltip';
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
var styles = require('./SuggestionsContextMenu.scss');
var personaCard = function (props) {
    return React.createElement(Icon, { className: styles.personaIcon, iconName: "ContactCard" /* ContactCard */ });
};
var PersonaContactCard = personaCardBehavior(personaCard);
var PeopleSuggestionMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(PeopleSuggestionMenuItem, _super);
    function PeopleSuggestionMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PeopleSuggestionMenuItem.prototype.render = function () {
        var suggestion = this.props.suggestion;
        return (React.createElement("div", { className: styles.personaSuggestion, key: suggestion.EmailAddresses[0], tabIndex: 0, 
            // VSO: 17221 We should change onMouseDown to onClick
            onMouseDown: function () {
                suggestionSelected(suggestion, CLICK_ACTION_SOURCE);
            } },
            React.createElement(PersonaControl, { emailAddress: suggestion.EmailAddresses[0], name: suggestion.DisplayName, showPersonaDetails: true, showPresence: false, size: PersonaSize.size28, onRenderPrimaryText: function (props) { return (React.createElement(TooltipHost, { content: props.primaryText, directionalHint: 0 /* topLeftEdge */, overflowMode: TooltipOverflowMode.Parent }, highlightDisplayText(suggestion.HighlightedDisplayName)
                    .filter(function (e) { return e.text.length > 0; })
                    .map(function (e) { return (React.createElement("div", { className: e.isHighlighted
                        ? styles.keywordMatchSuggestion
                        : styles.keywordNonMatchSuggestion }, e.text)); }))); } }),
            isControlFeatureEnabled('sea-personaCardInSuggestions') && (React.createElement(PersonaContactCard, { name: suggestion.DisplayName, emailAddress: suggestion.EmailAddresses[0], personaType: 'User' }))));
    };
    PeopleSuggestionMenuItem = tslib_1.__decorate([
        observer
    ], PeopleSuggestionMenuItem);
    return PeopleSuggestionMenuItem;
}(React.Component));
export default PeopleSuggestionMenuItem;
//# sourceMappingURL=PeopleSuggestionMenuItem.js.map